import { Box, List, ListItem, ListItemText, Typography } from '@mui/material';

const GUIDELINES = {
  'Keep it Short': 'Limit Reason names to 4-7 words for clarity.',
  'Reflect User Needs':
    'Choose names that indicate user needs, complaints, feelings, or enhancements. Examples: "Unable to...", "Help with...", "Issue with..." etc.',
  'Avoid Ambiguity': 'Ensure that names have a single interpretation.',
};

export const ReasonNameInfoTooltipContent = () => {
  return (
    <Box sx={{ p: '12px', maxWidth: 450 }}>
      <Typography variant="subtitle2" color="text.primary">
        Key Guidelines for Good Reason Name:
      </Typography>
      <List dense disablePadding sx={{ marginTop: 2 }}>
        {Object.entries(GUIDELINES).map(
          ([guidelineTitle, guidelineText], index) => (
            <ListItem key={guidelineText} disableGutters disablePadding>
              <ListItemText
                primary={`${index + 1}. ${guidelineTitle}: `}
                primaryTypographyProps={{
                  variant: 'caption',
                  component: 'span',
                  color: 'text.primary',
                  sx: {
                    display: 'inline',
                  },
                }}
                secondary={guidelineText}
                secondaryTypographyProps={{
                  variant: 'caption',
                  component: 'span',
                  color: 'text.secondary',
                  sx: {
                    display: 'inline',
                  },
                }}
                sx={{
                  display: 'inline-block',
                  pl: 1,
                  pb: 0,
                }}
              />
            </ListItem>
          ),
        )}
      </List>
    </Box>
  );
};
